export enum CancelationEmailDialogFormNamesEnum {
  FORM_NAME = 'CancelationEmailDialog',
  EMAIL = 'Email',
}
